import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Checkbox, Grid, InputAdornment, TextField } from '@mui/material';
import { Sidebar } from '../../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../../auth/GlobalUrl';
import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';


export default function RChildListing() {

    const [children, setchildren] = useState([])
    const navigate = useNavigate()
    const blankImage = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
    const [value, setValue] = useState('')
    const [tableFilter, setTableFilter] = useState([])

    const getData = () => {
        var url = `${baseURL}child/getAllChild/${localStorage.getItem('tenant_id')}`
        axios.get(url)
            .then((res) => {
                console.log(res.data.data)
                setchildren(res.data.data)
            }).catch((err) => {
                console.log(err)
            })
    }

    const onSearch = (e) => {
        if (e.target.value !== ' ') {
            setValue(e.target.value)
            const filterTable = children.filter(o => Object.keys(o).some(k => String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())))
            setTableFilter([...filterTable])
        } else {
            setValue(e.target.value)
            setchildren(...children)
        }

    }

    useEffect(() => {
        getData()
    }, [])
    return (
        <Sidebar>
            <Grid container >
                <Grid container spacing={2} mt={2} px={2} py={3} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                    <Grid item>
                        <TextField
                            id="input-with-icon-textfield"
                            onChange={onSearch}
                            value={value}
                            placeholder="Search Child"
                            size="medium"
                            sx={{ backgroundColor: 'white', minWidth: 400 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item>
                        {/* <Link to='/teacherdetails'><AddCircleIcon color="info" /></Link> */}
                        <Button
                            variant="other"
                            sx={{
                                background: "#1799CD",
                                color: "#ffffff",
                                border: "1px solid #1799CD",
                                marginLeft: "10px",
                            }}
                        // onClick={postData}
                        >
                            Remove Child
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid px={2}>
                <TableContainer component={Paper} sx={{ boxShadow: '0 0 5px 0 #888888' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ boxShadow: '0 0 5px 0 #888888' }}>
                                <TableCell sx={{ width: '50px' }}></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="left">Child Name</TableCell>
                                <TableCell align="left">Age</TableCell>
                                <TableCell align="left">Assign Teacher</TableCell>
                                <TableCell align="left">Class</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {value.length > 0 ? tableFilter.map((row, index) =>
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, boxShadow: '0 0 5px 0 #888888' }}
                                >
                                    <TableCell component="th" scope="row">
                                        <Checkbox />
                                    </TableCell>
                                    <TableCell align="left">
                                        <img
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                borderRadius: "50px",
                                            }}
                                            src={row.child_profileUrl ? row.child_profileUrl : blankImage}
                                        />
                                    </TableCell>
                                    <TableCell align="left">{row.child_name}</TableCell>
                                    <TableCell align="left">{row.child_age}</TableCell>
                                    <TableCell align="left">--</TableCell>
                                    <TableCell align="left">{row.child_class}</TableCell>
                                </TableRow>
                            ):children.map((row, index) =>
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, boxShadow: '0 0 5px 0 #888888' }}
                            >
                                <TableCell component="th" scope="row">
                                    <Checkbox />
                                </TableCell>
                                <TableCell align="left">
                                    <img
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            borderRadius: "50px",
                                        }}
                                        src={row.child_profileUrl ? row.child_profileUrl : blankImage}
                                    />
                                </TableCell>
                                <TableCell align="left">{row.child_name}</TableCell>
                                <TableCell align="left">{row.child_age}</TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">{row.child_class}</TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Grid container px={6}>
                    <Grid
                        item
                        mt={6}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <Button
                            variant="other"
                            sx={{ border: "1px solid #FF0000", color: "red" }}
                            onClick={() => {

                                //   navigate("/educators");
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="other"
                            sx={{
                                background: "#1799CD",
                                color: "#ffffff",
                                border: "1px solid #1799CD",
                                marginLeft: "10px",
                            }}
                        // onClick={postData}
                        >
                            Add Child
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Sidebar>
    )
}
